import React from 'react';
import { Link } from 'react-router-dom';
import { TableCell, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import { convertTokens } from '@date-fns/upgrade/v2';

import { CurrencyCode, currencyFormat } from 'utils/currencyFormat';

import { TransactionTypeLabels } from '../constants';
import { Transaction } from '../types';

import { BatchFileDownloadButton } from './BatchFileDownloadButton';
import { TransactionTableRow } from './TransactionTableRow';

export const GivingAccountTransferInboundTransactionRow = ({
  transaction,
  accountCurrency,
}: {
  transaction: Extract<Transaction, { __typename: 'GivingAccountTransferInbound' }>;
  accountCurrency: CurrencyCode;
}) => {
  const targetAmount = transaction.GivingAccountTransferOutbound?.amount;
  const targetCurrency = transaction.GivingAccountTransferOutbound?.GivingAccount
    .currencyCode as CurrencyCode;
  const rate = targetAmount ? targetAmount / transaction.amount : null;

  return (
    <TransactionTableRow
      collapsibleContent={
        rate &&
        targetAmount && (
          <>
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              Exchange rate
            </Typography>
            <br />
            <Typography variant="body2">
              {currencyFormat(transaction.amount, accountCurrency)} ={' '}
              {currencyFormat(targetAmount, targetCurrency)}
            </Typography>
            <br />
            <Typography variant="body2">
              {currencyFormat(1, accountCurrency)} = {currencyFormat(rate, targetCurrency)}
            </Typography>
          </>
        )
      }
    >
      <TableCell>
        <Typography variant="body2">
          {format(new Date(transaction.createdAt), convertTokens('MMM DD, YYYY'))}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{TransactionTypeLabels[transaction.__typename]}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          To{' '}
          <Link
            to={`/donations/ledger/${transaction.GivingAccountTransferOutbound?.GivingAccount.id}`}
          >
            {transaction.GivingAccountTransferOutbound?.GivingAccount.provider}/
            {transaction.GivingAccountTransferOutbound?.GivingAccount.currencyCode}
          </Link>
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {transaction.GivingAccountTransferOutbound?.GivingAccount.provider}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {currencyFormat(transaction.amount, accountCurrency)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {typeof transaction.balance === 'number' &&
            currencyFormat(transaction.balance, accountCurrency)}
        </Typography>
      </TableCell>
      <BatchFileDownloadButton />
    </TransactionTableRow>
  );
};
